//
//
//
//
//
//
//
//
//
//
//

import plan from './components/plan';
export default {
  name: 'Plan',
  components: {
    plan: plan
  }
};